import './components.css';
import katex from 'katex';

window.addEventListener('message', (e) => {
  if (e.data?.type === 'iframe-resize' && typeof e.data.height === 'number') {
    const iframe = Array.from(document.querySelectorAll('iframe')).find(
      (f) => f.contentWindow === e.source
    );
    if (iframe) {
      iframe.style.height = `${e.data.height}px`;
    }
  }
  if (e.data?.type === 'iframe-scroll' && typeof e.data.deltaY === 'number') {
    window.scrollBy(0, e.data.deltaY);
  }
});

document.querySelectorAll('.formula-block').forEach((el) => {
  const latex = el.getAttribute('data-formula');
  if (latex) {
    katex.render(latex, el as HTMLElement, {
      throwOnError: false,
      displayMode: true,
    });
  }
});
